import { useTranslation } from 'react-i18next';
import { Badge } from '@ooh/ui/components/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@ooh/ui/components/card';
import type { TagDefinition } from '@ooh/contracts';

export function DetailTagsCard({
  tags,
  clientView = false,
}: {
  tags: TagDefinition[];
  /** Suppresses the internal client-visible marker — see MediaUnitDetailView's `clientView` doc. */
  clientView?: boolean;
}) {
  const { t } = useTranslation('inventory');
  return (
    <Card data-testid="tags-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-base">{t('detail.tags.sectionTitle')}</CardTitle>
      </CardHeader>
      <CardContent>
        {tags.length === 0 ? (
          <span className="text-sm text-muted-foreground" data-testid="tags-empty-placeholder">
            {t('detail.tags.empty')}
          </span>
        ) : (
          <div className="flex flex-wrap gap-1.5">
            {tags.map((tag) => (
              <Badge
                key={tag.id}
                variant="outline"
                className="flex items-center gap-1 text-xs"
                data-testid={`tag-chip-${tag.id}`}
              >
                {tag.label}
                {tag.isClientVisible && !clientView ? (
                  <span
                    className="text-xs font-bold text-primary ml-1"
                    data-testid={`tag-chip-client-marker-${tag.id}`}
                    aria-label={t('detail.tags.clientVisibleMarker')}
                  >
                    {t('detail.tags.clientVisibleMarker')}
                  </span>
                ) : null}
              </Badge>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
